import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux';

import { Report, UnidataTable, Modal } from '~/components';
import {
    RadioGroup
} from '~/components/Form';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO, parse } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { number, t, parseDateString } from '~/helpers';
import { TypeFilters } from '~/components';

import api from '~/services/api';
import { isEmpty, includes, isArray } from 'lodash';
import { recordFiltering } from '~/store/modules/apuracaoInventario/actions';

import RecordDetails from './RecordDetails';


export default function ApuracaoInventario() {


    const [open, setOpen] = useState(true);
    const [grid, setGrid] = useState(false);
    const [query, setQuery] = useState({});
    const reference = useRef(null);

    const filterRef = useRef(null);
    const modalRef = useRef(null);

    const [post, setPost] = useState('')
    const [dataObjto, setDataObjto] = useState({});

    const dataRedux = useSelector((state) => state.apuracaoInventario);
    const titlePage = useMemo(() => 'Apuração Inventário', []);


    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
    const [dataHoraInicial, setDataHoraInicial] = useState('')
    const [dataHoraFinal, setDataHoraFinal] = useState('')




    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);

    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
    });

    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 1) {
                await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
                    abortEarly: false,
                });
            } else if (tipoTypeFilters == 5) {
                await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})

        } catch (err) {
            console.log(err)
            const form = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);

            }
            throw err;
        }
    }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])

    const headerUnidataTable = useMemo(
        () => [
            {
                id: 'post_desc',
                label: 'Posto',
                filter: {
                    type: 'text',
                },
            },
            {
                id: 'turn_datahora_ini',
                label: 'Turno Data Hora Início',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
            },
            {
                id: 'turn_datahora_fim',
                label: 'Turno Data Hora Fim',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
            },
            { id: 'oper_nome', label: 'Responsável' },
        ],
        []
    );

    const handleShowGrid = useCallback((data) => {
        const { post_cod_posto,
            turn_datahora_ini,
            turn_datahora_fim,
            tipoRel,
            codTurno } = data


        const dataQuery = {
            wherefield: ['turn_datahora_ini', 'turn_datahora_fim', 'tipoRel'],
            valuewherefield: [
                turn_datahora_ini,
                turn_datahora_fim,
                tipoRel,
            ],
            typewherefield: ['MAIOR_IGUAL', 'MENOR_IGUAL', 'EQUALS'],
        }

        if (!isEmpty(post_cod_posto)) {
            dataQuery.wherefield.push('post_cod_posto')
            dataQuery.valuewherefield.push(post_cod_posto)
            dataQuery.typewherefield.push('EQUALS')
        }

        setOpen(false)
        setGrid(true)
        setQuery(dataQuery)

    }, [])


    const handleSerializeForm = useCallback((param) => {

        const serializeObject = {
            ...param,
            post_cod_posto: post.post_cod_posto ? post.post_cod_posto : '',
            posto_str: post.post_desc ? post.post_desc : '',
            turn_datahora_ini: dataHoraInicial,
            turn_datahora_fim: dataHoraFinal,
            tipoRel: 1,
            codTurno: '',

            idtarefapath: "ApuracaoInventario.swf",
        }

        if (param.tipo == 'tela') {
            handleShowGrid(serializeObject)

        } else {
            return serializeObject
        }


    }, [dataHoraInicial, dataHoraFinal, post])

    const openModalWithRecordDetails = useCallback((data, heading) => {
        if (!isEmpty(data))
            modalRef.current.handleOpenModal({ data: { ...data, filter_datahora_ini: dataHoraInicial, filter_datahora_fim: dataHoraFinal } });
    }, [dataHoraFinal, dataHoraInicial]);


    if (grid && !isEmpty(query))
        return (
            <>
                <UnidataTable
                    fixed
                    header={headerUnidataTable}
                    read={recordFiltering}
                    redux={dataRedux}
                    title={titlePage}
                    query={query}
                    onRow={(value) => openModalWithRecordDetails(value)}
                    keys={['postoDesc']}
                    detach="postoDesc"
                    maxHeight="calc(100vh - 36rem)"
                    create={false}
                    update={false}
                    delete={false}
                />

                <Modal
                    disableBackdropClick
                    disableEscapeKeyDown
                    form
                    ref={modalRef}
                    title="Apuração de Inventário"
                    component={RecordDetails}
                    labelConfirm="Imprimir"
                    labelCancell="Fechar"
                />
            </>
        );


    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="RELATÓRIO DE APURAÇÃO DE INVENTÁRIO"
                relatorio="APUINVENTARIO"
                validate={handleValidate}
                serialize={(param) => handleSerializeForm(param)}
            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setPost(value);
                    }}
                />

                <TypeFilters
                    ref={filterRef}
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.turno'), value: 5 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />

                <RadioGroup
                    name="tipo"
                    label="Formato"
                    options={[
                        { label: 'PDF', value: 'pdf' },
                        { label: 'Excel', value: 'xls' },
                        { label: 'Tela', value: 'tela' }]
                    }
                    defaultValue="tela"
                    serialize={(value) => value}
                    row
                />

            </Report>
        </>

    )
}
